export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

export default class extends Component {
    static template = template;
    
    static defaults() {
        return {
            value1: false,
            value2: false,
            value3: false,
            checkedValue: {
                test: 1
            }
        }
    };
}